export const INPUT_NAMES = {
  surname: 'surnameRef',
  name: 'nameRef',
  patronymic: 'patronymicRef',
  date: 'dateRef',
  email: 'emailRef',
  cartNumber: 'cartNumberRef',
  phone: 'phoneRef',
} as const
